import React from "react";
import Navbar from '../accueil/navbar/Navbar';
import Footer from '../accueil/footer/Footer';
import Actualites from "./actualites/Actualites";
import '../scroll/Scroll.css';

const SERVER_ADDRESS = process.env.REACT_APP_SERVER_ADDRESS;

class DisplayActualites extends React.Component {
    constructor() {
        super();
        this.state = {
            actu: []
        }
          document.addEventListener('DOMContentLoaded', function() {
            window.onscroll = function(ev) {
              document.getElementById("cRetour").className = (window.pageYOffset > 100) ? "cVisible" : "cInvisible";
            };
          });
    }

    componentDidMount = () => {
        fetch(SERVER_ADDRESS + '/actualites')
            .then(res => res.json())
            .then(res => this.setState({ actu: res }))
    }

    render() {
        return (
            <div id="haut" className="sticky-wrap">
                <Navbar />
                <div className="all_actu_page align-items-center column">
                    <h1 className="title_glob_actu">Notre actualité</h1>
                    {this.state.actu.map((actualites) => (
                        <Actualites
                        titre={actualites.titre}
                        liens={actualites.liens}
                        text={actualites.text}
                        alt={actualites.alt}
                        />
                    ))}
                </div>
                <div className="sticky-footer">
                      <div><a id="cRetour" className="cInvisible" href="#haut"> </a></div>
                    <Footer />
                </div>
            </div >
        )
    }
}

export default DisplayActualites;
